import {useState} from 'react'
import {useAuth} from '../auth/AuthContext'

export function LoginPage() {
  const {login, useBearerToken, authenticating, error} = useAuth()
  const [token, setToken] = useState('')
  return (
    <main className="login-page">
      <section className="login-panel">
        <span className="eyebrow">Thermal Operations Console</span>
        <h1>KaldFlyte</h1>
        <p>
          Sign in through the configured identity provider using Authorization
          Code with PKCE.
        </p>
        <button
          className="primary-button"
          type="button"
          disabled={authenticating}
          onClick={() => void login()}
        >
          {authenticating ? 'Completing sign in…' : 'Sign in with OIDC'}
        </button>
        <details>
          <summary>Local development bearer token</summary>
          <label>
            Access token
            <textarea
              rows={4}
              value={token}
              onChange={(event) => setToken(event.target.value)}
            />
          </label>
          <button type="button" onClick={() => useBearerToken(token)}>
            Use bearer token
          </button>
        </details>
        {error ? <div className="state-panel state-error">{error}</div> : null}
      </section>
    </main>
  )
}
